/**
 * * Элемент загрузки файлов по url
 */
export default class ImportFilesFromUrlItem  {
	/**
	 * * Ссылка на файл
	 */
	Url!: string;
	/**
	 * * Название файла
	 */
	Name!: string;
	constructor(obj?: Partial<ImportFilesFromUrlItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
